import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10" }
const _hoisted_4 = {
  class: "position-relative",
  style: {"min-width":"220px","max-width":"300px","flex":"1 1 auto"}
}
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = {
  key: 0,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
  type: "button",
  style: {"background-color":"#EB9355"}
}
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  colspan: "5",
  class: "text-center py-5 text-muted"
}
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis text-center" }
const _hoisted_21 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_22 = { class: "dropdown-menu" }
const _hoisted_23 = {
  class: "dropdown-item",
  href: "javascript:void(0)"
}
const _hoisted_24 = {
  key: 1,
  class: "text-muted fs-13"
}
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_26 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_27 = { class: "mb-0 text-paragraph" }
const _hoisted_28 = { class: "fw-bold" }
const _hoisted_29 = { class: "fw-bold" }
const _hoisted_30 = { class: "fw-bold" }
const _hoisted_31 = {
  key: 0,
  class: "mt-15 mt-md-0"
}
const _hoisted_32 = { class: "pagination mb-0" }
const _hoisted_33 = {
  key: 0,
  class: "page-item"
}
const _hoisted_34 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 1,
  class: "page-item"
}
const _hoisted_37 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_38 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_39 = { class: "modal-content" }
const _hoisted_40 = { class: "modal-header" }
const _hoisted_41 = { class: "modal-title fs-5" }
const _hoisted_42 = { class: "modal-body" }
const _hoisted_43 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_44 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_45 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_46 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_47 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_48 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_52 = ["placeholder"]
const _hoisted_53 = { class: "invalid-feedback" }
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_56 = ["placeholder"]
const _hoisted_57 = { class: "invalid-feedback" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-md-12" }
const _hoisted_60 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = ["title"]
const _hoisted_63 = ["id", "value"]
const _hoisted_64 = ["for"]
const _hoisted_65 = { class: "modal-footer" }
const _hoisted_66 = {
  key: 0,
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}

import { ref, onMounted, reactive, inject, computed } from "vue";
import axios from 'axios';
import router from '../../router/index'
import { showToast, checkSessionValidate } from "../../utils/function";
import { current_permissions } from '../../utils/permission';
import { useRoute, useRouter } from 'vue-router'
import * as yup from 'yup';
import { useI18n } from "vue-i18n";
import { Permissions, Actions } from "@/utils/Model";

const itemsPerPage = 10;

// Computed pour les données à afficher (filtrées ou non)

export default /*@__PURE__*/_defineComponent({
  __name: 'PermissionsContent',
  setup(__props) {

const backApi = inject('back');
const { t } = useI18n();

let edit = 0;
let itemCode = '';
let code: string | null = '';

const selectedActions = ref([]);
const btnLoad = ref(true);

let token: string | null = localStorage.getItem('login_token');

// Références réactives
const permissionsTemp = ref(new Array<Permissions>());
const actionsTemp = ref(new Array<Actions>());

// Variables pour la recherche
const searchQuery = ref('');
const filteredPermissions = ref(new Array<Permissions>());

const errors = ref('');
const errorId = ref('');
const success = ref('');
const errorsBis = { 'name': '', 'description': '' };
const pageLoad = ref(false);

const formValues = reactive({
  name: "",
  description: "",
});

const schema = yup.object({
  name: yup.string().required('Le nom de la permission est requis'),
  description: yup.string().required('La description est requise'),
});

// Pagination côté client
const page = ref(1);
const dataToDisplay = computed(() => {
  return searchQuery.value ? filteredPermissions.value : permissionsTemp.value;
});

// Computed pour le total
const total = computed(() => dataToDisplay.value.length);

// Computed pour le nombre de pages
const numPages = computed(() => Math.max(1, Math.ceil(total.value / itemsPerPage)));

// Computed pour les pages de pagination
const paginationPages = computed(() => {
  const pages = [];
  const totalPages = numPages.value;
  const current = page.value;
  
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    if (current <= 3) {
      for (let i = 1; i <= 5; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(totalPages);
    } else if (current >= totalPages - 2) {
      pages.push(1);
      pages.push('...');
      for (let i = totalPages - 4; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      pages.push('...');
      for (let i = current - 1; i <= current + 1; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(totalPages);
    }
  }
  return pages;
});

// Computed pour les permissions paginées
const paginatedPermissions = computed(() => {
  const start = (page.value - 1) * itemsPerPage;
  return dataToDisplay.value.slice(start, start + itemsPerPage);
});

const setPage = (numPage) => {
  if (numPage >= 1 && numPage <= numPages.value) {
    page.value = numPage;
  }
};

// Méthode pour filtrer les permissions
const filterPermissions = () => {
  const query = searchQuery.value.toLowerCase().trim();
  
  if (!query) {
    filteredPermissions.value = [...permissionsTemp.value];
    page.value = 1;
    return;
  }

  filteredPermissions.value = permissionsTemp.value.filter(permission => {
    // Recherche dans le code, le nom et la description
    const matchesBasic = (
      (permission.code && permission.code.toLowerCase().includes(query)) ||
      (permission.name && permission.name.toLowerCase().includes(query)) ||
      (permission.description && permission.description.toLowerCase().includes(query))
    );

    // Recherche dans les actions
    const matchesActions = permission.actions && permission.actions.some(action => 
      action.route && action.route.toLowerCase().includes(query)
    );

    return matchesBasic || matchesActions;
  });

  // Réinitialiser la page à 1 après un filtre
  page.value = 1;
};

// Méthode pour effacer la recherche
const clearSearch = () => {
  searchQuery.value = '';
  filteredPermissions.value = [...permissionsTemp.value];
  page.value = 1;
};

const initField = () => {
  formValues.name = '';
  formValues.description = "";
  selectedActions.value = [];
  itemCode = '';
  edit = 0;
  errorId.value = ''
  errors.value = ''
}

function formatDateFr(value) {
  if (value) {
    const year = value.getFullYear();
    let month = value.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = value.getDate();
    day = day < 10 ? '0' + day : day;
    return day + '/' + month + '/' + year;
  }
}

// Récupère une page depuis l'API (forme { data, pagination })
const fetchPermissionsPage = (targetPage: number) => {
  const url = `${backApi}/secure/permissions/?page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const getPermissions = async () => {
  try {
    const first = await fetchPermissionsPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchPermissionsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    permissionsTemp.value = collected.sort((a, b) => {
      const nameA = a.name ? a.name.toUpperCase() : '';
      const nameB = b.name ? b.name.toUpperCase() : '';
      return nameA.localeCompare(nameB);
    });
    filteredPermissions.value = [...permissionsTemp.value];
  } catch (error: any) {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const getActions = () => {
  return axios.get(backApi + '/secure/actions/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      actionsTemp.value = response.data.sort((a, b) => {
        const routeA = a.route ? a.route.toUpperCase() : '';
        const routeB = b.route ? b.route.toUpperCase() : '';
        return routeA.localeCompare(routeB);
      });
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const changeStatus = (status, code) => {
  axios.put(`${backApi}/secure/operators/${code}/status`, {
    code: code,
    status: (status == 'ACTIVE') ? 'INACTIVE' : 'ACTIVE'
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    router.go();
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const showOperator = (code) => {
  axios.get(backApi + '/secure/actions/' + code + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      formValues.name = response.data.name;
      formValues.description = response.data.description;
      selectedActions.value = response.data.actions;
      itemCode = response.data.code;
      edit = 1;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          console.log(error.response);
        }
      }
    });
}

const save = () => {
  if (edit == 0) {
    storePermission()
  } else {
    updatePermission()
  }
}

const storePermission = () => {
  try {
    schema.validateSync(formValues);
    axios.post(`${backApi}/secure/permissions/new`, {
      name: formValues.name,
      description: formValues.description,
      actions: selectedActions.value
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        showToast("Permission " + formValues.name.toLowerCase() + " enregistré avec succès", "green");
        initField();
        setTimeout(() => {
          router.go();
        }, 500);
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
  }
}

const updatePermission = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);
    axios.put(`${backApi}/secure/operators/${itemCode}/edit`, {
      name: formValues.name,
      description: formValues.description,
      actions: selectedActions
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Modification effectuée avec succès", "green");
        router.go();
      }
    }).catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

onMounted(async () => {
  checkSessionValidate(1)
  const route = useRoute();
  code = route.params.id;

  try {
    await Promise.all([
      getPermissions(),
      getActions(),
    ]);
  } finally {
    pageLoad.value = true;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                onInput: filterPermissions,
                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                placeholder: _ctx.$t('permissions.searchPlaceholder')
              }, null, 40, _hoisted_5), [
                [_vModelText, searchQuery.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: "/permissions/add/null",
                class: "sidebar-sub-menu-link"
              }, {
                default: _withCtx(() => [
                  (_unref(current_permissions)('create_permission'))
                    ? (_openBlock(), _createElementBlock("button", _hoisted_7, [
                        _createTextVNode(_toDisplayString(_ctx.$t('permissions.addPermission')) + " ", 1),
                        _cache[11] || (_cache[11] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("table", _hoisted_10, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('permissions.code')), 1),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('permissions.permission')), 1),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('permissions.description')), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('permissions.viewActions')), 1),
                    _cache[12] || (_cache[12] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (paginatedPermissions.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                        _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.$t('permissions.noResults')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedPermissions.value, (permission) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: permission.code
                    }, [
                      _createElementVNode("td", _hoisted_17, _toDisplayString(permission.code), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(permission.name === null ? '' : permission.name), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(permission.description === null ? '' : permission.description), 1),
                      _createElementVNode("td", _hoisted_20, [
                        (permission.actions !== null && permission.actions.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _cache[13] || (_cache[13] = _createElementVNode("button", {
                                class: "btn btn-none dropdown-toggle border-0",
                                type: "button",
                                "data-bs-toggle": "dropdown",
                                "aria-expanded": "false"
                              }, [
                                _createElementVNode("i", { class: "flaticon-eye" })
                              ], -1)),
                              _createElementVNode("ul", _hoisted_22, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permission.actions, (action) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: action.code
                                  }, [
                                    _createElementVNode("a", _hoisted_23, _toDisplayString(action.route), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('permissions.noActions')), 1))
                      ]),
                      _createElementVNode("td", _hoisted_25, [
                        _createVNode(_component_router_link, {
                          to: `/permissions/add/${permission.code}`,
                          class: "sidebar-sub-menu-link",
                          style: {"text-decoration":"none"}
                        }, {
                          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                            _createElementVNode("i", { class: "flaticon-pen" }, null, -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (filteredPermissions.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("p", _hoisted_27, [
                    _createTextVNode(_toDisplayString(_ctx.$t('permissions.showing')) + " ", 1),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(filteredPermissions.value.length > 0 ? Math.min((page.value-1)*itemsPerPage + 1, filteredPermissions.value.length) : 0), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('permissions.to')) + " ", 1),
                    _createElementVNode("span", _hoisted_29, _toDisplayString(Math.min(page.value*itemsPerPage, filteredPermissions.value.length)), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('permissions.outOf')) + " ", 1),
                    _createElementVNode("span", _hoisted_30, _toDisplayString(filteredPermissions.value.length), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('permissions.results')), 1)
                  ]),
                  (numPages.value > 1)
                    ? (_openBlock(), _createElementBlock("nav", _hoisted_31, [
                        _createElementVNode("ul", _hoisted_32, [
                          ((page.value-1)>0)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (setPage(page.value-1))),
                                  "aria-label": "Previous"
                                }, [...(_cache[15] || (_cache[15] = [
                                  _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginationPages.value, (numPage) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: numPage,
                              class: "page-item"
                            }, [
                              (numPage==page.value)
                                ? (_openBlock(), _createElementBlock("a", _hoisted_34, _toDisplayString(numPage), 1))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: "page-link",
                                    onClick: ($event: any) => (setPage(numPage))
                                  }, _toDisplayString(numPage), 9, _hoisted_35))
                            ]))
                          }), 128)),
                          ((page.value+1)<=numPages.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (setPage(page.value+1))),
                                  "aria-label": "Next"
                                }, [...(_cache[16] || (_cache[16] = [
                                  _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(save, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("h1", _hoisted_41, _toDisplayString(_unref(edit) == 0 ? _ctx.$t('permissions.addPermission') : _ctx.$t('permissions.editPermission')), 1),
              _cache[17] || (_cache[17] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_42, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("h6", _hoisted_44, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_45, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createElementVNode("h6", _hoisted_47, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('permissions.permission')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formValues.name) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['name'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('permissions.namePlaceholder'),
                        onBlur: _cache[4] || (_cache[4] = ($event: any) => (validate('name'))),
                        onKeyup: _cache[5] || (_cache[5] = ($event: any) => (validate('name')))
                      }, null, 42, _hoisted_52), [
                        [_vModelText, formValues.name]
                      ]),
                      _createElementVNode("span", _hoisted_53, _toDisplayString(errorsBis['name']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t('permissions.description')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formValues.description) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['description'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('permissions.descriptionPlaceholder'),
                        onBlur: _cache[7] || (_cache[7] = ($event: any) => (validate('description'))),
                        onKeyup: _cache[8] || (_cache[8] = ($event: any) => (validate('description')))
                      }, null, 42, _hoisted_56), [
                        [_vModelText, formValues.description]
                      ]),
                      _createElementVNode("span", _hoisted_57, _toDisplayString(errorsBis['description']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.$t('permissions.actions')), 1),
                    _createElementVNode("div", _hoisted_61, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actionsTemp.value, (action) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: action.code,
                          class: "form-check mb-2 col-md-4",
                          title: action.description
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: 'action-' + action.code,
                            value: action.route,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedActions).value = $event))
                          }, null, 8, _hoisted_63), [
                            [_vModelCheckbox, selectedActions.value]
                          ]),
                          _createElementVNode("label", {
                            class: "form-check-label text-black",
                            for: 'action-' + action.code
                          }, _toDisplayString(action.route), 9, _hoisted_64)
                        ], 8, _hoisted_62))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_65, [
              (_unref(current_permissions)('create_operator', 'edit_operator'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_66, [
                    _cache[18] || (_cache[18] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(edit) == 0 ? _ctx.$t('permissions.save') : _ctx.$t('permissions.edit')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _cache[19] || (_cache[19] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})